<template>
<section class="aboutUs">
  <div class="container">
    <div class="row">
      <div class="col-4">
        <h3>Подход</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur consectetur dignissimos ea eaque, excepturi laboriosam minima molestiae nemo obcaecati odio omnis reiciendis repellendus sapiente similique sint, suscipit, temporibus voluptate! Animi consequuntur dolore et expedita hic ipsam sapiente sequi, ullam voluptate!</p>
      </div>
      <div class="col-6">
        <picture>
          <source srcset="../../public/static/images/team/3.webp">
          <img src="../../public/static/images/team/3.jpg" alt="">
        </picture>
      </div>
    </div>
    <div class="row">
      <ul>
        <li class="col-5">
          <picture>
            <source srcset="../../public/static/images/team/4.webp">
            <img src="../../public/static/images/team/4.jpg" alt="">
          </picture>
        </li>
        <li class="col-5">
          <h3>Реальность</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci aliquid aspernatur at atque blanditiis commodi deleniti eius est fugit illo inventore mollitia nemo nesciunt nisi nostrum nulla odio, optio pariatur perspiciatis placeat provident rem saepe sed, sequi sit suscipit temporibus velit voluptates voluptatum. Ab aliquam consequuntur, culpa debitis dicta odio pariatur possimus quasi, quia rem saepe, velit vero voluptatem.</p>
        </li>
        <li class="col-5">
          <picture>
            <source srcset="../../public/static/images/team/6.webp">
            <img src="../../public/static/images/team/6.jpg" alt="">
          </picture>
        </li>
        <li class="col-5">
          <h3>Реализация</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet dicta, dignissimos dolorem impedit laborum mollitia necessitatibus obcaecati possimus! Dolore dolorem excepturi quibusdam soluta. Commodi corporis cumque in molestias repellat ullam.</p>
        </li>
        <li class="col-5">
          <picture>
            <source srcset="../../public/static/images/team/5.webp">
            <img src="../../public/static/images/team/5.jpg" alt="">
          </picture>
        </li>
        <li class="col-5">
          <picture>
            <source srcset="../../public/static/images/team/7.webp">
            <img src="../../public/static/images/team/7.jpg" alt="">
          </picture>
        </li>
      </ul>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'SectionAboutUs',
  components: {},
  methods: {},
  computed: {},
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.aboutUs {
  padding: 100px 0 45px 0;
  @media (max-width: 997.98px) {
    padding: 15px 0;
  }
  h3 {
    font-weight: 500;
    font-size: 4rem;
    margin-bottom: 30px;
    @media (max-width: 997.98px) {
      margin-bottom: 10px;
    }
  }
  p {
    margin-bottom: 30px;
    font-size: 2rem;
    color: #333333;
    display: flex;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -30px;
    .col-4 {
      display: flex;
      flex-direction: column;
      flex: 0 0 40%;
      max-width: 40%;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0 30px;
      position: relative;
      justify-content: space-around;
      @media (max-width: 997.98px) {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
    .col-6 {
      display: flex;
      flex-direction: column;
      flex: 0 0 60%;
      max-width: 60%;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0 30px;
      position: relative;
      @media (max-width: 997.98px) {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
    img {
      height: 600px;
      width: 100%;
      object-fit: cover;
      object-position: center;
      @media (max-width: 997.98px) {
        height: 300px;
      }
    }
    ul {
      column-count: 2;
      width: 100%;
      position: relative;
      margin-top: 100px;
      @media (max-width: 997.98px) {
        margin-top: 30px;
      }
      @media (max-width: 767.98px) {
        column-count: 1;
        margin-top: 0;
      }
      .col-5 {
        width: 100%;
        position: relative;
        padding: 0 30px;
        box-sizing: border-box;
        margin: 100px 0;
        &:nth-child(2n+2) {
          img {
            margin-top: 50px;
          }
        }
        &:nth-child(2n-1) {
          img {
            margin-bottom: 50px;
          }
        }
        @media (max-width: 767.98px) {
          margin: 30px 0;
          &:nth-child(2n+2) {
            img {
              margin-top: 0;
            }
          }
          &:nth-child(2n-1) {
            img {
              margin-bottom: 0;
            }
          }
        }
      }
      p {
        max-width: 400px;
      }
    }
  }
}
</style>
